<template>
  <div v-analytics="pageView" class="account">
    <EHero class="account__hero">
      <header class="account__header">
        <ELogo
          :title="$t('common.logo.titletag')"
          href="/"
          rel="noopener"
          class="account__logo"
        />
      </header>
      <div class="account__wrapper">
        <Nuxt />
      </div>
      <EMainFooter
        class="account__footer"
        :show-cards="false"
      />
    </EHero>
  </div>
</template>

<script>
import EHero from '~/components/hero';
import EMainFooter from '~~/common/vue/components/main-footer';
import ELogo from '~~/common/vue/components/logo';
import keyboardMode from '~~/common/vue/mixins/keyboard-mode';

import { pageView } from '~/analytics';

export default {
  name: 'EAccount',
  head() {
    return {
      htmlAttrs: { lang: this.$store.state.global.locale },
    };
  },
  components: {
    EHero,
    EMainFooter,
    ELogo,
  },
  mixins: [keyboardMode],
  data() {
    return {
      pageView,
    };
  },
};
</script>

<style lang="scss" scoped>
.account {
  max-width: 100%;
  overflow: hidden;
  background: var(--color-background-quaternary);
}

.account__hero {
  justify-content: space-between;
}

.account__header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 100%;
  margin-bottom: $space-1l;
  z-index: $z-index-l;

  @include tablet {
    justify-content: flex-start;
  }
}

.account__logo {
  display: block;
  height: 53px;
  width: 75px;
  margin-top: $space-m;

  @include tablet {
    margin-left: $space-m;
  }
}

.account__wrapper {
  max-width: 440px;
  color: var(--color-text-primary);
  padding: 0 $space-2l;
  text-align: center;
  margin: 0 auto;

  @include mobile-l {
    padding: 0;
  }
}

.account__footer {
  background-color: var(--color-background-quaternary);
}
</style>
